import './helpers.js';

function includesArray(bigArray, targetArray) {
	return bigArray.some(sub =>
		sub.length === targetArray.length &&
		sub.every((val, i) => val === targetArray[i])
	);
}
jQuery(document).ready(function($) {
    // scroll animate for anchor links
    $('a[href^="#"]').on('click', function(event) {
        const target = $(this.getAttribute('href'));
        if (target.length) {
            event.preventDefault();
            $('html, body').stop().animate({
                scrollTop: target.offset().top
            }, 1000);
        }
    });

    $('body').on('click', '.main-header-row__bulk-order', function (e) {
        e.preventDefault();
        erpFrontend.openModal('erp-theme-modal-bulk-order');
        return false;
    })
	$('body').on('click', '.request-quote-trigger', function (e) {
		e.preventDefault();
		erpFrontend.openModal('erp-theme-modal-bulk-quote');
		return false;
	})

    // qty input field
    $('body').on('click', '.erp-theme-quantity-input__btn--minus', function (e) {
        e.preventDefault();
        const input = $(this).siblings('input');
        let value = parseInt(input.val());
        if (value > 1) {
            value--;
            input.val(value);
        }

        // if value less than 1, set it to 1
        if (value < 1) {
            input.val(1);
        }

        input.trigger('change');
        return false;
    })

    $('body').on('click', '.erp-theme-quantity-input__btn--plus', function (e) {
        e.preventDefault();
        const input = $(this).siblings('input');
        let value = parseInt(input.val());
        value++;
        input.val(value);

        // if val is greater than 100, set it to 100
        if (value > 99999) {
            input.val(99999);
        }

        input.trigger('change');
        return false;
    })

    // check value on input change
    $('body').on('change', '.erp-theme-quantity-input input', function (e) {
        let value = parseInt($(this).val());

        if (value < 1) {
            $(this).val(1);
        } else if (value > 99999) {
            $(this).val(99999);
        }
    })

    $('body').on('submit', '.erp-theme-form-bulk-order', function (e) {
        e.preventDefault();
        erpFrontend.loaderOn();

        const $form = $(this);
        // collect all inputs vals in arr in erp-theme-form-group div
        const items = $form.find('.erp-theme-form-group').map(function () {
            const key = $(this).find('input[name=bulk_order_item]').val();

            if(key === '') {
                // continue to next iteration
                return;
            }

            return {'item_key' : key, 'item_qty': $(this).find('input[name=bulk_order_item_qty]').val()};
        }).get();

        const items_for_parse = $form.find('[name=items_textarea]').val();

        erpFrontend.ajax('erp_bulk_order', {items, items_for_parse}, function (res) {
            if( erpFrontend.ajaxResultCheck(res) ) {
                erpFrontend.toast(res.message, 'success', 10000);
                $('.count-in-cart').html(res.cart_count);
                $('.count-in-cart').addClass('active');

                if($('.erp-price-reporter-page-cart').length) {
                    window.location.reload();
                }

                if(res.same_sku_modal.length) {
                    // remove modal if exists
                    $('#erp-theme-modal-bulk-order-same-sku').remove();
                    // append modal to body
                    $('body').append(res.same_sku_modal);
                    erpFrontend.openModal('erp-theme-modal-bulk-order-same-sku');
                }

                // clear all inputs
                $form.find('input[name=bulk_order_item]').val('');
                $form.find('input[name=bulk_order_item_qty]').val('1');
                $form.find('[name=items_textarea]').val('');
            }
            else {
                erpFrontend.toast(res.message, 'unsuccess', 10000);
            }

            erpFrontend.loaderOff();
        })

    })
	$('body').on('submit', '.erp-theme-form-bulk-quote', function (e) {
		e.preventDefault();
		erpFrontend.loaderOn();

		const $form = $(this);
		// collect all inputs vals in arr in erp-theme-form-group div
		const items = $form.find('.erp-theme-form-group').map(function () {
			const key = $(this).find('input[name=bulk_order_item]').val();

			if (key === '') {
				// continue to next iteration
				return;
			}

			return {'item_key': key, 'item_qty': $(this).find('input[name=bulk_order_item_qty]').val()};
		}).get();
		const items_for_parse = $form.find('[name=items_textarea]').val();
		erpFrontend.ajax('erp_bulk_quote', {items, items_for_parse}, function (res) {
			if( erpFrontend.ajaxResultCheck(res) ) {
				erpFrontend.toast(res.message, 'success', 10000);
				// clear all inputs
				$form.find('input[name=bulk_order_item]').val('');
				$form.find('input[name=bulk_order_item_qty]').val('1');
				setTimeout(() => {
					window.location.href = res.redirect;
				}, 2500);
				return false;
			}
			else {
				erpFrontend.toast(res.message, 'unsuccess', 10000);
			}
			erpFrontend.closeModal('erp-theme-modal-bulk-quote');
			erpFrontend.loaderOff();
		})


	})

    $('body').on('click', '.erp-theme-form-order-bulk-add-item', function (e){
        e.preventDefault();
        erpFrontend.loaderOn();

        // ajax
        erpFrontend.ajax('erp_bulk_order_add_item', {}, function (res) {
            if( erpFrontend.ajaxResultCheck(res) ) {
                $('.erp-theme-page .erp-theme-form-fields').append(res.html);
                erpFrontend.toast(res.message, 'success', 4000);
            }
            else {
                erpFrontend.toast(res.message, 'unsuccess', 4000);
            }

            erpFrontend.loaderOff();
        })
    })

    erpFancybox.bind('[data-fancybox]');

    $('body').on('change', '.erp-price-reporter-shortcode-cart-wrap .erp-theme-quantity-input input', function (e){
        erpFrontend.loaderOn();
        const $this = $(this);
        const product = $this.closest('.cart-item').attr('data-product');
        const product_id = $this.closest('.cart-item').attr('data-product-id');
        const qty = $this.val();

        erpFrontend.ajax('erp_update_cart_item_qty', {product, qty}, function (res) {
            if( erpFrontend.ajaxResultCheck(res) ) {
                erpFrontend.toast(res.message, 'success', 4000);
                $('.count-in-cart').html(res.cart_count);
                if(!res.hide_price) {
                    $('.cart-item[data-product-id="'+product_id+'"]').find('.price').html(res.current_product_total);
                    $('.summary-item--tax .summary-item--value').html(res.tax);
                    $('.summary-item--subtotal .summary-item--value').html(res.sub_total_price);
                    $('.summary-item--total .summary-item--value').html(res.total_price);
                }
				$('input#cxml').val(res.cxml)
            }
            else {
                erpFrontend.toast(res.message, 'unsuccess', 4000);
            }

            erpFrontend.loaderOff();
        })
    })
    $('body').on('change', '.summary .summary-item--shipping-additional-item select', function () {
        erpFrontend.loaderOn();
        let state = $('#billing_state').length > 0 ? $('#billing_state').val() : false
        let zip = $('#billing_zip_code').length > 0 ? $('#billing_zip_code').val() : false
        let shipping_additional = $('.summary .summary-item--shipping-additional-item select');
        let shipping_additional_selected = [];
        shipping_additional.each(function (index) {
            let parent = $(this).closest('.summary-item--shipping-additional-item')
            if($(this).val() === 'Yes') {
                parent.find('.shipping-additional-site-text .shipping-additional-amount').addClass('hide-amount')
                parent.find('.erp-price-reporter-select-block .shipping-additional-amount').removeClass('hide-amount')
            } else {
                parent.find('.shipping-additional-site-text .shipping-additional-amount').removeClass('hide-amount')
                parent.find('.erp-price-reporter-select-block .shipping-additional-amount').addClass('hide-amount')
            }
            shipping_additional_selected.push({
                site: $(this).attr('data-site-text'),
                memo: $(this).attr('data-memo-text'),
                amount: $(this).attr('data-amount'),
                value: $(this).val()
            });
        });
        let shipping_additional_data = JSON.stringify(shipping_additional_selected);
        erpFrontend.ajax('erp_update_cart_total_shipping_additional', {shipping_additional_data, state, zip}, function (res) {
            if( erpFrontend.ajaxResultCheck(res) ) {
                erpFrontend.toast(res.message, 'success', 4000);
                $('.summary .summary-item--total .summary-item--value').html(res.total_price);
            }
            else {
                erpFrontend.toast(res.message, 'unsuccess', 4000);
            }
            erpFrontend.loaderOff();
        })
    })
    // click enter on header-search triggers search
    $('body').on('keypress', '.header-search', function (e) {
        if (e.which === 13) {
            $(this).siblings('.header-search-submit').click();
        }
    })

    $('body').on('click', '.header-search-submit', function (e) {
        e.preventDefault();
        erpFrontend.loaderOn();

        const $parent = $(this).closest('.main-header-row__search');
        const search = $parent.find('.header-search').val();
        const maxResults = 3;

        erpFrontend.ajax('erp_price_reporter_products_search', {search, maxResults}, function (res) {
            clearTimeout(timeoutForSearchResults);

            if( erpFrontend.ajaxResultCheck(res) ) {

                if(res.results !== undefined && !res.results.length) {
                    $parent.find('.header-search-results--products').hide()
                    $parent.find('.header-search-results--no-found').show()
                } else {
                    $parent.find('.header-search-results--products').html(res.results);
                    $parent.find('.header-search-results--products').show()
                    $parent.find('.header-search-results--no-found').hide()
                }

                $parent.find('.header-search-results-wrap').addClass('active');
                setTimeout(() => {
                    $parent.find('.header-search-results').addClass('active');
                    erpFrontend.loaderOff();
                }, 100);
            }
            else {
                erpFrontend.toast(res.message, 'unsuccess', 4000);
                erpFrontend.loaderOff();
            }
        })
    })

    // hide search results on click outside
    let timeoutForSearchResults;
    $('body').on('click', function (e) {
        if (!$(e.target).closest('.main-header-row__search').length) {

            $('.main-header-row__search .header-search-results').removeClass('active');


            timeoutForSearchResults = setTimeout(function() {
                $('.main-header-row__search .header-search-results-wrap').removeClass('active');
            }, 400);
        }
    })

    $('body').on('click', '.mobile-menu-btn', function (e){
        e.preventDefault();
        $('body').addClass('mobile-menu-active');

        setTimeout(function() {
            $('.main-header-row__menu').addClass('active');
            $('body').addClass('mobile-menu-active-opened');
        }, 100);
    })

    $('body').on('click', '.close-mobile-menu', function (e){
        e.preventDefault();
        $('.main-header-row__menu').removeClass('active');
        $('body').removeClass('mobile-menu-active-opened');
        setTimeout(function() {
            $('body').removeClass('mobile-menu-active');
        }, 200);
    })

    $('html').on('click', 'body.mobile-menu-active-opened',function (e){
        // if $(e.target) is body element, close mobile menu
        if($(e.target).is('body.mobile-menu-active-opened')) {
            e.preventDefault();
            $('.main-header-row__menu').removeClass('active');
            $('body').removeClass('mobile-menu-active-opened');
            setTimeout(function() {
                $('body').removeClass('mobile-menu-active');
            }, 200);
        }
    })

    // faq section
    $('body').on('click', '.section-faq--item__question', function (e){
        e.preventDefault();
        const $this = $(this);
        const $parent = $this.closest('.section-faq--item');
        const $answer = $parent.find('.section-faq--item__answer');

        if($parent.hasClass('active')) {
            $answer.slideUp();
            $parent.removeClass('active');
        } else {
            $answer.slideDown();
            $parent.addClass('active');
        }
    })

    const featuredSlider = new erpSwiper('.section-featured-slider--slider .swiper', {
            loop: true,
            speed: 400,
            spaceBetween: 24,
            slidesPerView: "auto",
            autoplay: {
                delay: 6000,
                disableOnInteraction: false,
            },
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
        });


    const productsSliders = $('.section-banners-slider .swiper')
    let sliderID = 1;

    productsSliders.each(function (index) {
        let slider = $(this)
        slider.addClass('swiper-' + sliderID)
        slider.find('.swiper-pagination').addClass('swiper-pagination-' + sliderID)
        let delay = slider.attr('data-delay')
        let transition = slider.attr('data-transition')

        let options = {
            loop: true,
            spaceBetween: 0,
            slidesPerView: 1,
            pagination: {
                el: '.swiper-pagination-' + sliderID,
                clickable: true
            },
        }
        if(slider.attr('data-autoplay') === 'yes') {
            options.speed = transition
            options.autoplay = {
                delay: delay,
                disableOnInteraction: false,
            }
        }
        new erpSwiper('.swiper-' + sliderID, options);
        sliderID++;
    })
    const productSlider = new erpSwiper('.section-products-slider .swiper', {
        loop: true,
        speed: 400,
        spaceBetween: 0,
        slidesPerView: 1,
        autoplay: {
            delay: 6000,
            disableOnInteraction: false,
        },
        pagination: {
            el: ".swiper-pagination",
            clickable: true
        },
    });

    const infiniteSlider = new erpSwiper('.section-infinite-images-slider .swiper', {
        spaceBetween: 20,
        grabCursor: true,
        slidesPerView: 4,
        loop: true,
        autoplay: {
            delay: 0,
            disableOnInteraction: true
        },
        loopAdditionalSlides: 20,
        freeMode: true,
        speed: 1000,
        freeModeMomentum: false,
        allowTouchMove: false,
        breakpoints: {
            '768': {
                slidesPerView: 8,
                spaceBetween: 20,
            }
        }
    });
    // let speed = 1000;
    // const infiniteSlider = $('.section-infinite-images-slider .slick').slick({
    //     arrows: false,
    //     infinite: true,
    //     pauseOnFocus: false,
    //     pauseOnHover: false,
    //     touchMove: false,
    //     variableWidth: true,
    //     slidesToScroll:1,
    //     //centerMode: true,
    //     speed: speed,
    //     autoplaySpeed: 0,
    //     autoplay: true,
    //     cssEase: 'linear'
    // });
    //
    // infiniteSlider.on('afterChange', function(event, slick, currentSlide, nextSlide){
    //     const nextSlideWidth = infiniteSlider.find('.slide:nth(' + (currentSlide + 1) + ')').width();
    //     speed = Math.floor((1500 * nextSlideWidth) / 100);
    //     infiniteSlider.slick('slickSetOption', {
    //         speed: speed,
    //     }, true);
    //
    // });
    $('body').on('click', '.erp-price-reporter-shortcode-categories-list--item-title', function(e){
        if(window.matchMedia('(max-width: 768px)').matches) {
            const $this = $(this)
            const $parent = $this.closest('.erp-price-reporter-shortcode-categories-list--item');
            $parent.toggleClass('active')
        }
    })

    $('body').on('click', '.site-header .main-header-row__menu-item.has-children > a svg', function (e) {
        if(window.matchMedia('(max-width: 992px)').matches) {
            e.preventDefault()
            const $this = $(this)
            const $parent = $this.closest('.main-header-row__menu-item');
            $parent.toggleClass('active')
        }
    })
    $('body').on('click', '.pricereporter-mobile-menu .main-header-row__menu-item.has-children .products-catalog', function (e) {
        e.preventDefault()
        const $this = $(this)
        const $parent = $this.closest('.main-header-row__menu-item');
        $parent.toggleClass('active')
    })
    // $('body').on('click', '.has-subcategories>a svg', function (e) {
    //     e.preventDefault()
    //     e.stopImmediatePropagation()
    //     e.stopPropagation()
    //     let parent = $(this).closest('.has-subcategories')
    //     let submenu = parent.find('.erp-theme-header-categories--level-1-list--subcategories').length === 1 ? parent.find('.erp-theme-header-categories--level-1-list--subcategories') : parent.find('.erp-theme-header-categories--level-3-list')
    //     parent.toggleClass('submenu-open')
    //     if(parent.hasClass('submenu-open')) {
    //         submenu.slideDown()
    //     } else {
    //         submenu.slideUp()
    //     }
    // })

    $('body').on('mouseover', '.erp-theme-header-categories--level-1-li', function (e) {
        const $this = $(this);

       // if(window.matchMedia('(min-width: 992px)').matches) {
            $('.erp-theme-header-categories--level-2').removeClass('active')

            if ($this.hasClass('has-subcategories')) {
                const categoryName = $this.attr('data-category-name')
                const categoryUrl = $this.attr('data-category-url')
                const subcategoriesHtml = $this.find('.erp-theme-header-categories--level-1-list--subcategories').html()

                $('.erp-theme-header-categories--level-2 .erp-theme-header-categories--header span').html(categoryName)
                $('.erp-theme-header-categories--level-2 .erp-theme-header-categories--header-see-all').attr('href', categoryUrl)
                $('.erp-theme-header-categories--level-2 .erp-theme-header-categories--level-2-wrap').html(subcategoriesHtml)
                $('.erp-theme-header-categories--level-2').addClass('active')
            }
       // }
    })

    $('body').on('click', '.erp-theme-header-categories--level-1-li > a', function (e) {
       // if(window.matchMedia('(max-width: 992px)').matches) {
            const $this = $(this);
            const $li = $this.closest('li');

            if ($li.hasClass('has-subcategories')) {
                e.preventDefault()

                if(!$li.hasClass('active')){
                    $('.erp-theme-header-categories--level-1-li').removeClass('active');
                    $this.closest('.erp-theme-header-categories--level-1-list').addClass('level-2-opened');
                    $li.addClass('active');
                } else {
                    $li.removeClass('active');
                    $this.closest('.erp-theme-header-categories--level-1-list').removeClass('level-2-opened');
                }
            }
      //  }
    })

    $('body').on('click', '.erp-theme-header-categories--level-2-li > a', function (e) {
       // if(window.matchMedia('(max-width: 992px)').matches) {
            const $this = $(this);
            const $li = $this.closest('li');

            if ($li.hasClass('has-subcategories')) {
                e.preventDefault()

                if(!$li.hasClass('active')){
                    $('.erp-theme-header-categories--level-2-li').removeClass('active');
                    $this.closest('.erp-theme-header-categories--level-1-li').addClass('level-3-opened');
                    $li.closest('.erp-theme-header-categories--level-2-list').addClass('active');
                    $li.addClass('active');
                } else {
                    $li.closest('.erp-theme-header-categories--level-2-list').removeClass('active');
                    $this.closest('.erp-theme-header-categories--level-1-li').removeClass('level-3-opened');
                    $li.removeClass('active');
                }
            }
       // }
    })

    $('body').on('mouseleave', '.main-header-row__menu-item--catalog', function (e) {
        $('.erp-theme-header-categories--level-2').removeClass('active')
    })

    $('body').on('click', '.erp-price-reporter-page-category--header-view a', function (e) {
        e.preventDefault();
        const $this = $(this);
        const view = $this.attr('data-view-type');
        $('.erp-price-reporter-page-category--products').attr('data-view', view);
        $this.siblings('a').removeClass('active');
        $this.addClass('active');

        erpFrontend.setCookie('erp_price_reporter_category_product_view_type', view, 1);
    })

    $('body').on('click', '.erp-price-reporter-page-category--header-sort > a', function (e) {
        e.preventDefault()
        const $this = $(this);
        $this.toggleClass('active')

        if($this.hasClass('active')) {
            // slidedown 150ms
            $this.siblings('.erp-price-reporter-page-category--header-sort-dropdown').slideDown(150);
        } else {
            $this.siblings('.erp-price-reporter-page-category--header-sort-dropdown').slideUp(150);
        }
    })

    // close dropdown on click outside
    $('body').on('click', function (e) {
        if (!$(e.target).closest('.erp-price-reporter-page-category--header-sort').length) {
            $('.erp-price-reporter-page-category--header-sort > a').removeClass('active');
            $('.erp-price-reporter-page-category--header-sort-dropdown').slideUp(150);
        }
    })

    // click on .erp-price-reporter-page-category--header-sort-dropdown a
    $('body').on('click', '.erp-price-reporter-page-category--header-sort-dropdown a', function (e) {
        e.preventDefault();
        erpFrontend.loaderOn();
        const $this = $(this);
        const $parent = $this.closest('.erp-price-reporter-page-category--header-sort-dropdown');
        const $sort = $parent.siblings('.erp-price-reporter-page-category--header-sort > a');
        const sortColumn = $this.attr('data-sortColumn');
        const sortDesc = $this.attr('data-sortDesc');

        $sort.find('span').html($this.text());
        $sort.removeClass('active');
        $parent.slideUp(150);

        // add or change sort query param
        const url = new URL(window.location.href);
        url.searchParams.set('sortDesc', sortDesc);
        url.searchParams.set('sortColumn', sortColumn);

        // remove parameter page if exists
        url.searchParams.delete('cur-page');

        window.location.href = url
    })

    $('body').on('submit', '.erp-theme-modal--same-sku-products', function (e) {
        e.preventDefault();
        erpFrontend.loaderOn();
        const $this = $(this);
        const formData = [];

        $.each($this.find('.erp-theme-modal--same-sku-products-item'), function (i, el) {
            const $item = $(el);
            const itemProductsData = JSON.parse($item.attr('data-products'));
            const selectedProduct = $item.find('input[type=radio]:checked').val();

            // find selected product in itemProductsData by localSku
            const selectedProductData = itemProductsData.find(item => item.localSku === selectedProduct);

            // push to formData
            formData.push(selectedProductData);
        })

        erpFrontend.ajax('erp_bulk_order_add_same_sku_to_cart', {formData}, function (res) {
            if( erpFrontend.ajaxResultCheck(res) ) {
                erpFrontend.toast(res.message, 'success', 4000);
                $('.count-in-cart').html(res.cart_count);

                if(parseInt(res.cart_count) > 0) {
                    $('.count-in-cart').addClass('active');
                }
            }
            else {
                erpFrontend.toast(res.message, 'unsuccess', 4000);
            }

            erpFrontend.closeModal('erp-theme-modal-bulk-order-same-sku');

            erpFrontend.loaderOff();
        })
    })

    $('body').on('click', '.erp-price-reporter-page-category--filters-item-dropdown-link', function (e){
        e.preventDefault();
        const $this = $(this);

        $this.toggleClass('active');

        if($this.hasClass('active')) {
            $this.siblings('.erp-price-reporter-page-category--filters-item-dropdown').slideDown(150);
        } else {
            $this.siblings('.erp-price-reporter-page-category--filters-item-dropdown').slideUp(150);
        }
    })

    $.each($('.erp-price-reporter-slider-range'), function (i, el) {
        const $this = $(el);
        // const $slider = $this.find('.erp-price-reporter-slider-range-range');
        // $slider.slider({
        //     range: true,
        //     min: 0,
        //     max: 1000,
        //     values: [0, 0],
        //     step: 1,
        //     slide: function(event, ui) {
        //         console.log(ui.values[0], ui.values[1]);
        //         console.log($this.find('.erp-price-reporter-slider-range-label-max'));
        //         $this.find('.erp-price-reporter-slider-range-label-min').val(`$${ui.values[0]}`);
        //         $this.find('.erp-price-reporter-slider-range-label-max').val(`$${ui.values[1]}`);
        //     }
        // });

        // $this.find('.erp-price-reporter-slider-range-label-min').val(`$${$slider.slider("values", 0)}`);
        // $this.find('.erp-price-reporter-slider-range-label-max').val(`$${$slider.slider("values", 1)}`);

        // event on change input
        $this.find('.erp-price-reporter-slider-range-label-min').on('change', function () {
            const $min = $(this);
            const value = parseInt($min.val().replace('$', ''));
            const maxVal = parseInt($this.find('.erp-price-reporter-slider-range-label-max').val().replace('$', ''));

            if(value > 0) {
                if(maxVal > 0 && value > maxVal) {
                    $min.val(`$${maxVal}`);
                } else {
                    $min.val(`$${value}`);
                }
                $min.addClass('active');
            } else {
                $min.removeClass('active');
            }

        })

        $this.find('.erp-price-reporter-slider-range-label-max').on('change', function () {
            const $max = $(this);
            const value = parseInt($max.val().replace('$', ''));
            const minVal = parseInt($this.find('.erp-price-reporter-slider-range-label-min').val().replace('$', ''));

            if(value > 0) {
                if(minVal > 0 && value < minVal) {
                    $max.val(`$${minVal}`);
                } else {
                    $max.val(`$${value}`);
                }
                $max.addClass('active');
            } else {
                $max.removeClass('active');
            }
        })

        const $currencyInputs = $this.find('.erp-price-reporter-slider-range-label');
        $currencyInputs.inputmask({
            alias: 'currency',
            prefix: '',
            rightAlign: false,
            allowMinus: false,
            digits: 0,
            showMaskOnHover: false,
            autoUnmask: true,
            placeholder: '',
        });
    });

    $('body').on('click', '.erp-price-reporter-page-category--filters-apply-btn', function (e) {
        e.preventDefault();
        erpFrontend.loaderOn();
        const url = new URL(window.location.href);

        // remove parameter page if exists
        url.searchParams.delete('cur-page');
        url.searchParams.delete('manufacturers');
        url.searchParams.delete('price-from');
        url.searchParams.delete('price-to');
        url.searchParams.delete('category-filter-key');
        url.searchParams.delete('category-filter-value');

		let selected_departments  = [];
		let selected_categories   = [];
		let selected_subcategories= [];
		let departments_filter = [];
		let categories_filter = [];
		let subcategories_filter = [];
		$('.erp-price-reporter-page-category--filters-departments-group .erp-price-reporter-department').each(function () {
			let input = $(this).find('input')
			if (input.is(':checked')) {
				selected_departments.push(input.val())
				departments_filter.push('department-filter')
				departments_filter.push(input.val())
			}
		})
		$('.erp-price-reporter-page-category--filters-categories-group .erp-price-reporter-category').each(function () {
			let input = $(this).find('input')
			if (input.is(':checked')) {
				selected_categories.push(input.val());
				categories_filter.push('category-filter');
				categories_filter.push(input.val());
			}
		})
		$('.erp-price-reporter-page-category--filters-subcategories-group .erp-price-reporter-subcategory').each(function () {
			let input = $(this).find('input')
			if (input.is(':checked')) {
				selected_subcategories.push(input.val());
				subcategories_filter.push('subcategory-filter');
				subcategories_filter.push(input.val());
			}
		})
		if(selected_departments.length > 0) {
			erpFrontend.setCookie('erp_price_reporter_filter_department', selected_departments[0], 1);
		} else {
			erpFrontend.setCookie('erp_price_reporter_filter_department', '', -10);
		}
		if(selected_categories.length > 0) {
			erpFrontend.setCookie('erp_price_reporter_filter_category', selected_categories[0], 1);
		} else {
			erpFrontend.setCookie('erp_price_reporter_filter_category', '', -10);
		}
		if(selected_subcategories.length > 0) {
			erpFrontend.setCookie('erp_price_reporter_filter_subcategory', selected_subcategories[0], 1);
		} else {
			erpFrontend.setCookie('erp_price_reporter_filter_subcategory', '', -10);
		}
		const categories = selected_subcategories.length ? subcategories_filter : selected_categories.length ? categories_filter : departments_filter;
        let filter = false;

        let manufacturers = [];
        $.each($('input[name=manufacturer_filter]'), function (i, el) {
            const $this = $(el);
            if($this.is(':checked')) {
                filter = true;
                manufacturers.push($this.val());
            }
        })

        if(manufacturers.length) {
            url.searchParams.set('manufacturers', manufacturers.join(','));
        }

        // if($('input[name=category_filter]:checked').length) {
        //     filter = true;
        //     const selectedCategory = $('input[name=category_filter]:checked');
        //     url.searchParams.set('category-filter-key', selectedCategory.attr('data-filter-key'));
        //     url.searchParams.set('category-filter-value', selectedCategory.val());
		//
        //     // get current url params
        //     const params = new URLSearchParams(window.location.search);
        //     const categoryFilterValue = params.get('category-filter-value');
        //     if(categoryFilterValue !== selectedCategory.val()) {
        //         url.searchParams.delete('manufacturers');
        //     }
        // }
		if(categories.length) {
            filter = true;
            url.searchParams.set('category-filter-key', categories[0]);
            url.searchParams.set('category-filter-value', categories[1]);

            // get current url params
            const params = new URLSearchParams(window.location.search);
            const categoryFilterValue = params.get('category-filter-value');
			url.searchParams.delete('manufacturers');
        }

        let priceFrom = parseInt($('input[name=price-from]').val().replace('$', ''));
        let priceTo = parseInt($('input[name=price-to]').val().replace('$', ''));

        if(priceFrom > 0) {
            filter = true;
            url.searchParams.set('price-from', priceFrom);
        }

        if(priceTo > 0) {
            filter = true;
            url.searchParams.set('price-to', priceTo);
        }

        if(!filter) {
            erpFrontend.toast('No filters selected', 'unsuccess', 4000);
            erpFrontend.loaderOff();
            return;
        }

        window.location.href = url
    })

    $('body').on('change', 'input[name=category_filter]', function () {
       // need to uncheck other category inputs
        $('input[name=category_filter]').not(this).prop('checked', false);
    });

    const $catalogCategoryInput = $('input[name=category_filter]:checked').first();
    if($catalogCategoryInput.length) {
        const $categoryDropdownParent = $catalogCategoryInput.closest('.erp-price-reporter-page-category--filters-item-dropdown');
        $categoryDropdownParent.css('display', 'block');
        $categoryDropdownParent.closest('.erp-price-reporter-form-group').closest('.erp-price-reporter-page-category--filters-item-dropdown').css('display', 'block');

        $categoryDropdownParent.siblings('.erp-price-reporter-page-category--filters-item-dropdown-link').addClass('active')
        $categoryDropdownParent.closest('.erp-price-reporter-form-group').closest('.erp-price-reporter-page-category--filters-item-dropdown').siblings('.erp-price-reporter-page-category--filters-item-dropdown-link').addClass('active')
    }

    $('body').on('click', '.erp-price-reporter-page-category--filters-current-label', function (e) {
        e.preventDefault()
        if(window.matchMedia('(max-width: 768px)').matches) {
            $('.erp-price-reporter-page-category--filters-items').addClass('active');
        }
    })

    // click on erp-price-reporter-page-category--filters-items but not on inner elements
    $('body').on('click', '.erp-price-reporter-page-category--filters-items', function (e) {
        if(window.matchMedia('(max-width: 768px)').matches && $(e.target).hasClass('erp-price-reporter-page-category--filters-items')) {
            $('.erp-price-reporter-page-category--filters-items').removeClass('active');
        }
    })
    $('body').on('click', '.erp-price-reporter-page-category--filters-item-mobile-title-close', function (e) {
        e.preventDefault();
        const $this = $(this);
        $('.erp-price-reporter-page-category--filters-items').removeClass('active');
    })
    
    $('body').on('click', '.erp-price-reporter-page-category--filters-current-clear-all', function () {
		erpFrontend.setCookie('erp_price_reporter_filter_department', '', -10);
		erpFrontend.setCookie('erp_price_reporter_filter_category', '', -10);
		erpFrontend.setCookie('erp_price_reporter_filter_subcategory', '', -10);
        erpFrontend.loaderOn();
    })

    $('body').on('submit', '.erp-price-reporter-orders-search', function (e) {
        erpFrontend.loaderOn();
    })
    $('body').on('input', '.erp-price-reporter-address input', function () {
        $('.erp-price-reporter-account-addresses-form .btn').removeClass('hide-save-address')
        if(!$('.erp-price-reporter-add-address-btn').hasClass('hide-add-address')) {
            $('.erp-price-reporter-add-address-btn').addClass('hide-add-address')
        }
    })
    $('body').on('change', '.erp-price-reporter-address select', function () {
        $('.erp-price-reporter-account-addresses-form .btn').removeClass('hide-save-address')
        if(!$('.erp-price-reporter-add-address-btn').hasClass('hide-add-address')) {
            $('.erp-price-reporter-add-address-btn').addClass('hide-add-address')
        }
        if ($(this).val() === 'shipping') {
            $(this).closest('.erp-price-reporter-address').find('.erp-price-reporter-add-shipping-address').addClass('hide-add-shipping-address')
        }
        if ($(this).val() === 'billing') {
            $(this).closest('.erp-price-reporter-address').find('.erp-price-reporter-add-shipping-address').removeClass('hide-add-shipping-address')
        }
    })
    $('body').on('change', '#use_billing_address', function () {
        if($(this).is(':checked')) {
            $('#shipping_saved_address_id').prop("selectedIndex", 0)
            $('#shipping_saved_address_id').trigger('change')
            let first_name = $('#billing_first_name').val()
            let last_name  = $('#billing_last_name').val()
            let address    = $('#billing_address').val()
            let address_2  = $('#billing_address_2').val()
            let address_3  = $('#billing_address_3').val()
            let city       = $('#billing_city').val()
            let zip_code   = $('#billing_zip_code').val()
            let state      = $('#billing_state').val()
            $('#shipping_first_name').val(first_name)
            $('#shipping_last_name').val(last_name)
            $('#shipping_address').val(address)
            $('#shipping_address_2').val(address_2)
            $('#shipping_address_3').val(address_3)
            $('#shipping_city').val(city)
            $('#shipping_zip_code').val(zip_code)
            $('#shipping_state').val(state)

            $('#shipping_first_name').attr('readonly','readonly')
            $('#shipping_last_name').attr('readonly','readonly')
            $('#shipping_address').attr('readonly','readonly')
            $('#shipping_address_2').attr('readonly','readonly')
            $('#shipping_address_3').attr('readonly','readonly')
            $('#shipping_city').attr('readonly','readonly')
            $('#shipping_zip_code').attr('readonly','readonly')
            $('#shipping_state').attr('disabled','disabled')
            $('#shipping_saved_address_id').attr('disabled','disabled')

        } else {
            $('#shipping_first_name').attr('readonly', false)
            $('#shipping_last_name').attr('readonly', false)
            $('#shipping_address').attr('readonly', false)
            $('#shipping_address_2').attr('readonly', false)
            $('#shipping_address_3').attr('readonly', false)
            $('#shipping_city').attr('readonly', false)
            $('#shipping_zip_code').attr('readonly', false)
            $('#shipping_state').attr('disabled', false)
            $('#shipping_saved_address_id').attr('disabled', false)
        }
    })
    $('body').on('change', '#billing_saved_address_id, #billing_state', function () {
        if($('#use_billing_address').is(':checked')) {
            setTimeout(function () {
                $('#shipping_saved_address_id').prop("selectedIndex", 0)
                $('#shipping_saved_address_id').trigger('change')
                let first_name = $('#billing_first_name').val()
                let last_name  = $('#billing_last_name').val()
                let address    = $('#billing_address').val()
                let address_2  = $('#billing_address_2').val()
                let address_3  = $('#billing_address_3').val()
                let city       = $('#billing_city').val()
                let zip_code   = $('#billing_zip_code').val()
                let state      = $('#billing_state').val()
                $('#shipping_first_name').val(first_name)
                $('#shipping_last_name').val(last_name)
                $('#shipping_address').val(address)
                $('#shipping_address_2').val(address_2)
                $('#shipping_address_3').val(address_3)
                $('#shipping_city').val(city)
                $('#shipping_zip_code').val(zip_code)
                $('#shipping_state').val(state)

                $('#shipping_first_name').attr('readonly','readonly')
                $('#shipping_last_name').attr('readonly','readonly')
                $('#shipping_address').attr('readonly','readonly')
                $('#shipping_address_2').attr('readonly','readonly')
                $('#shipping_address_3').attr('readonly','readonly')
                $('#shipping_city').attr('readonly','readonly')
                $('#shipping_zip_code').attr('readonly','readonly')
                $('#shipping_state').attr('disabled','disabled')
                $('#shipping_saved_address_id').attr('disabled','disabled')
            }, 100)

        }
    })
    $('body').on('input', '#billing_first_name, #billing_last_name, #billing_address, #billing_address_2, #billing_address_3, #billing_city, #billing_state, #billing_zip_code', function () {
        if($('#use_billing_address').is(':checked')) {
            setTimeout(function () {
                $('#shipping_saved_address_id').prop("selectedIndex", 0)
                $('#shipping_saved_address_id').trigger('change')
                let first_name = $('#billing_first_name').val()
                let last_name  = $('#billing_last_name').val()
                let address    = $('#billing_address').val()
                let address_2  = $('#billing_address_2').val()
                let address_3  = $('#billing_address_3').val()
                let city       = $('#billing_city').val()
                let zip_code   = $('#billing_zip_code').val()
                let state      = $('#billing_state').val()
                $('#shipping_first_name').val(first_name)
                $('#shipping_last_name').val(last_name)
                $('#shipping_address').val(address)
                $('#shipping_address_2').val(address_2)
                $('#shipping_address_3').val(address_3)
                $('#shipping_city').val(city)
                $('#shipping_zip_code').val(zip_code)
                $('#shipping_state').val(state)

                $('#shipping_first_name').attr('readonly','readonly')
                $('#shipping_last_name').attr('readonly','readonly')
                $('#shipping_address').attr('readonly','readonly')
                $('#shipping_address_2').attr('readonly','readonly')
                $('#shipping_address_3').attr('readonly','readonly')
                $('#shipping_city').attr('readonly','readonly')
                $('#shipping_zip_code').attr('readonly','readonly')
                $('#shipping_state').attr('disabled','disabled')
                $('#shipping_saved_address_id').attr('disabled','disabled')
            }, 100)

        }
    })
    $('body').on('input select', '.checkout-form-fields-group-billing input, .checkout-form-fields-group-shipping input, #billing_saved_address_id, #shipping_saved_address_id, #billing_state, #shipping_state', function () {
        setTimeout(function () {
            let b_first_name = $('#billing_first_name').val() !== '';
            let b_last_name  = $('#billing_last_name').val() !== '';
            let b_address    = $('#billing_address').val() !== '';
            let b_city       = $('#billing_city').val() !== '';
            let b_zip = $('#billing_zip_code').val();
            let b_zip_code   = /^\d{5,}$/.test(b_zip);
            let b_state      = $('#billing_state').val() !== '';
            let s_first_name = $('#shipping_first_name').val() !== '';
            let s_last_name  = $('#shipping_last_name').val() !== '';
            let s_address    = $('#shipping_address').val() !== '';
            let s_city       = $('#shipping_city').val() !== '';
            let s_zip = $('#shipping_zip_code').val();
            let s_zip_code   = /^\d{5,}$/.test(s_zip);
            let s_state      = $('#shipping_state').val() !== '';
            let is_filled = b_first_name && b_last_name && b_address && b_city && b_zip_code && b_state && s_first_name && s_last_name && s_address && s_city && s_zip_code && s_state;
            if (is_filled) {
                $('#erp-price-reporter-form-checkout .btn-add-new-card').removeClass('checkout-add-card-disable')
            } else {
                $('#erp-price-reporter-form-checkout .btn-add-new-card').addClass('checkout-add-card-disable')
            }
        }, 100)
    })
    $('body').on('click', '.btn-add-new-card', function (e){
        e.preventDefault();
        erpFrontend.loaderOnAddCard();
        let checkout_user_data = {
            'b_saved_address_id': $('#billing_saved_address_id').val(),
            'b_first_name': $('#billing_first_name').val(),
            'b_last_name' : $('#billing_last_name').val(),
            'b_address'   : $('#billing_address').val(),
            'b_address_2' : $('#billing_address_2').val(),
            'b_address_3' : $('#billing_address_3').val(),
            'b_city'      : $('#billing_city').val(),
            'b_zip_code'  : $('#billing_zip_code').val(),
            'b_state'     : $('#billing_state').val(),
            's_saved_address_id': $('#shipping_saved_address_id').val(),
            's_first_name': $('#shipping_first_name').val(),
            's_last_name' : $('#shipping_last_name').val(),
            's_address'   : $('#shipping_address').val(),
            's_address_2' : $('#shipping_address_2').val(),
            's_address_3' : $('#shipping_address_3').val(),
            's_city'      : $('#shipping_city').val(),
            's_zip_code'  : $('#shipping_zip_code').val(),
            's_state'     : $('#shipping_state').val(),
            'use_billing_address': $('#use_billing_address').is(':checked'),
            'payment_method': $('.payment-method .payment_method:checked').val()
        }
        localStorage.setItem('checkout_user_data', JSON.stringify(checkout_user_data))

        // ajax
        erpFrontend.ajax('erp_add_new_card', {}, function (res) {
            if(erpFrontend.ajaxResultCheck(res)) {
                // redirect after 2 seconds
                setTimeout(() => {
                    window.location.href = res.redirect;
                }, 2500);
                return false;
            }
            erpFrontend.loaderOff();
        })
    })
    $('body').on('click', '.erp-price-reporter-page-account .erp-account-order-detail--email-invoice', function (e) {
        e.preventDefault();
        erpFrontend.loaderOn();
        let order_id = $(this).attr('data-order-id')
        erpFrontend.ajax('erp_email_invoice', {order_id}, function (res) {
            erpFrontend.loaderOff();
            if(res.status) {
                erpFrontend.toast(res.message, 'success', 4000);
            } else {
                erpFrontend.toast(res.message, 'unsuccess', 4000);
            }
        })
    })
    $('body').on('click', '.erp-price-reporter-page-account .erp-account-order-detail--date-tracking-link', function (e) {
        e.preventDefault();
        erpFrontend.loaderOn();
        let order_id = $(this).attr('data-order-id')
        erpFrontend.ajax('erp_web_email_invoice', {order_id}, function (res) {
            erpFrontend.loaderOff();
            if(res.status) {
                erpFrontend.toast(res.message, 'success', 4000);
            } else {
                erpFrontend.toast(res.message, 'unsuccess', 4000);
            }
        })
    })
    $('body').on('change', '#billing_state', function (e) {
        let state = $('#billing_state').val()
        let zip = $('#billing_zip_code').val()
        e.preventDefault();
        erpFrontend.ajax('erp_calc_sales_tax', {state, zip}, function (res) {
            $('.summary-item.summary-item--tax .summary-item--value').html(res.tax)
            $('.summary-item.summary-item--shipping .summary-item--value').html(res.shipping)
            if(res.shipping_type === 'message') {
                $('.summary .summary-item--shipping-additional').addClass('shipping-additional-amount-hide')
                $('.summary-item.summary-item--shipping .summary-item--value').html('')
                $('.summary-item.summary-item--shipping-message').html(res.shipping)
            } else {
                $('.summary .summary-item--shipping-additional').removeClass('shipping-additional-amount-hide')
                $('.summary-item.summary-item--shipping .summary-item--value').html(res.shipping)
                $('.summary-item.summary-item--shipping-message').html('')
            }
            $('.summary-item.summary-item--subtotal .summary-item--value').html(res.subtotal)
            $('.summary-item.summary-item--total .summary-item--value').html(res.total)
        })
    })
    $('body').on('input', '#billing_zip_code', function (e) {
        let zip = $('#billing_zip_code').val()
        if(/^\d{5,}$/.test(zip)) {
            let state = $('#billing_state').val()
            e.preventDefault();
            erpFrontend.ajax('erp_calc_sales_tax', {state, zip}, function (res) {
                $('.summary-item.summary-item--tax .summary-item--value').html(res.tax)
                if(res.shipping_type === 'message') {
                    $('.summary .summary-item--shipping-additional').addClass('shipping-additional-amount-hide')
                    $('.summary-item.summary-item--shipping .summary-item--value').html('')
                    $('.summary-item.summary-item--shipping-message').html(res.shipping)
                } else {
                    $('.summary .summary-item--shipping-additional').removeClass('shipping-additional-amount-hide')
                    $('.summary-item.summary-item--shipping .summary-item--value').html(res.shipping)
                    $('.summary-item.summary-item--shipping-message').html('')
                }
                $('.summary-item.summary-item--subtotal .summary-item--value').html(res.subtotal)
                $('.summary-item.summary-item--total .summary-item--value').html(res.total)
            })
        }
    })
    $('body').on('change', '#billing_saved_address_id', function (e) {
        setTimeout(function () {
            let state = $('#billing_state').val()
            let zip = $('#billing_zip_code').val()
            e.preventDefault();

            erpFrontend.ajax('erp_calc_sales_tax', {state, zip}, function (res) {
                $('.summary-item.summary-item--tax .summary-item--value').html(res.tax)
                if(res.shipping_type === 'message') {
                    $('.summary .summary-item--shipping-additional').addClass('shipping-additional-amount-hide')
                    $('.summary-item.summary-item--shipping .summary-item--value').html('')
                    $('.summary-item.summary-item--shipping-message').html(res.shipping)
                } else {
                    $('.summary .summary-item--shipping-additional').removeClass('shipping-additional-amount-hide')
                    $('.summary-item.summary-item--shipping .summary-item--value').html(res.shipping)
                    $('.summary-item.summary-item--shipping-message').html('')
                }
                $('.summary-item.summary-item--subtotal .summary-item--value').html(res.subtotal)
                $('.summary-item.summary-item--total .summary-item--value').html(res.total)
            })
        }, 200)
    })
    $('body').on('click', '.site-header .has-submenu .submenu-trigger', function () {
        let parent = $(this).closest('.has-submenu')
        let menu = parent.find('.main-header-row__menu-submenu')
        menu.toggleClass('menu-opened')
        if(menu.hasClass('menu-opened')) {
            menu.slideDown({
                start: function () {
                    $(this).css({
                        display: "flex"
                    })
                }
            })
        } else {
            menu.slideUp()
        }
    })
    $('body').on('blur', '#billing_zip_code', function () {
        let billing_zip = $(this).val()
        if(!(/^[0-9][0-9-]{3,}[0-9]$/.test(billing_zip))) {
            erpFrontend.toast('Billing zip code must contain at least 5 digits', 'unsuccess', 4000);
            $(this).addClass('has-error')
        }
    })
    $('body').on('blur', '#shipping_zip_code', function () {
        let shipping_zip = $(this).val()
        if(!(/^[0-9][0-9-]{3,}[0-9]$/.test(shipping_zip))) {
            erpFrontend.toast('Shipping zip code must contain at least 5 digits', 'unsuccess', 4000);
            $(this).addClass('has-error')
        }
    })
    $('body').on('focus', '#billing_zip_code, #shipping_zip_code', function () {
        $(this).removeClass('has-error')
    })
    $('body').on('click', '.btn-proceed-checkout', function (e) {
        let selects = $('.summary-item--shipping-additional .shipping_additional')
        let proceed_disable = false;
        let messages = []
        selects.each(function (index) {
            let el = $(this)
            let siteText = el.attr('data-site-text')
            let siteErrorMessage = 'Please answer the "' + siteText + '" question.'
            if(el.val() === 'Select') {
                proceed_disable = true
                messages.push(siteErrorMessage)
            }
        })
        if(proceed_disable) {
            e.preventDefault()
            $('.cart-with-products .error-messages').html(messages.join('<br>'))
        }
    })
    $('body').on('change', '.erp-price-reporter-page-checkout .payment-method .payment_method', function (e) {
        $('.erp-price-reporter-page-checkout .payment-method').removeClass('payment-method-selected')
        $(this).closest('.payment-method').addClass('payment-method-selected')
    })
	$('body').on('change', '.erp-price-reporter-page-category--filters-departments-group input', function (e) {
		let selected_departments = [];
		$('.erp-price-reporter-page-category--filters-departments-group input').prop('checked', false)
		$(this).prop('checked', true)
		selected_departments.push($(this).closest('.erp-price-reporter-department').attr('data-department-key'))
		if(selected_departments.length === 0) {
			$('.erp-price-reporter-page-category--filters-categories-group .erp-price-reporter-category').removeClass('hide-item')
			$('.erp-price-reporter-page-category--filters-subcategories-group .erp-price-reporter-subcategory').removeClass('hide-item')
		} else {
			$('.erp-price-reporter-page-category--filters-categories-group .erp-price-reporter-category').each(function () {
				let department = $(this).attr('data-department-key');
				if(!selected_departments.includes(department)) {
					$(this).addClass('hide-item')
					$(this).find('input').prop('checked', false);
				} else {
					$(this).removeClass('hide-item')
				}
			})
			$('.erp-price-reporter-page-category--filters-subcategories-group .erp-price-reporter-subcategory').each(function () {
				let department = $(this).attr('data-department-key');
				if(!selected_departments.includes(department)) {
					$(this).addClass('hide-item')
					$(this).find('input').prop('checked', false);
				} else {
					$(this).removeClass('hide-item')
				}
			})
		}

	})
	$('body').on('change', '.erp-price-reporter-page-category--filters-categories-group input', function (e) {
		let selected_departments = [];
		let selected_categories = [];
		$('.erp-price-reporter-page-category--filters-categories-group input').prop('checked', false);
		$(this).prop('checked', true);
		selected_departments.push(['department-filter', $(this).attr('data-department-key')])
		$('.erp-price-reporter-page-category--filters-categories-group .erp-price-reporter-category').each(function () {
			if ($(this).find('input').is(':checked')) {
				let department = $(this).attr('data-department-key');
				let category = $(this).attr('data-category-key');
				selected_categories.push([department, category]);
			}
		})
		if(selected_categories.length === 0) {
			$('.erp-price-reporter-page-category--filters-subcategories-group .erp-price-reporter-subcategory').removeClass('hide-item')
			if(selected_departments.length > 0) {
				$('.erp-price-reporter-page-category--filters-subcategories-group .erp-price-reporter-subcategory').each(function () {
					let department = $(this).attr('data-department-key');
					if(!selected_departments.includes(department)) {
						$(this).addClass('hide-item')
						$(this).find('input').prop('checked', false);
					}
				})
			}
		} else {
			$('.erp-price-reporter-page-category--filters-subcategories-group .erp-price-reporter-subcategory').each(function () {
				let department = $(this).attr('data-department-key');
				let category = $(this).attr('data-category-key');
				if(!includesArray(selected_categories, [department, category])) {
					$(this).addClass('hide-item')
					$(this).find('input').prop('checked', false);
				} else {
					$(this).removeClass('hide-item')
				}
			})
		}
	})
	$('body').on('change', '.erp-price-reporter-page-category--filters-subcategories-group input', function () {
		$('.erp-price-reporter-page-category--filters-subcategories-group input').prop('checked', false);
		$(this).prop('checked', true);
	})
});
jQuery(window).on('load', function () {

	let filter_department = erpFrontend.getCookie('erp_price_reporter_filter_department');
	let filter_category = erpFrontend.getCookie('erp_price_reporter_filter_category');
	let filter_subcategory = erpFrontend.getCookie('erp_price_reporter_filter_subcategory');
	if(filter_department !== null) {
		jQuery('.erp-price-reporter-page-category--filters-departments-group .erp-price-reporter-department').each(function () {
			let value = jQuery(this).find('input').val();
			if(filter_department === value) {
				jQuery(this).find('input').click()
				return false;
			}
		})
	}
	if(filter_category !== null) {
		jQuery('.erp-price-reporter-page-category--filters-categories-group .erp-price-reporter-category:not(.hide-item)').each(function () {
			let value = jQuery(this).find('input').val();
			if(filter_category === value) {
				jQuery(this).find('input').click()
				return false;
			}
		})
	}
	if(filter_subcategory !== null) {
		jQuery('.erp-price-reporter-page-category--filters-subcategories-group .erp-price-reporter-subcategory:not(.hide-item)').each(function () {
			let value = jQuery(this).find('input').val();
			if(filter_subcategory === value) {
				jQuery(this).find('input').click()
				return false;
			}
		})
	}

    erpFrontend.ajax('erp_get_cart_count', {}, function (res) {
        let cart_badge =  jQuery('.count-in-cart')
        if(res.status) {
            cart_badge.addClass('active')
            cart_badge.text(res.message)
        } else {
            cart_badge.removeClass('active')
            cart_badge.text('')
        }
    })
    setTimeout(function () {
        let b_first_name_1 = jQuery('#billing_first_name').val() !== '';
        let b_last_name_1  = jQuery('#billing_last_name').val() !== '';
        let b_address_1    = jQuery('#billing_address').val() !== '';
        let b_city_1       = jQuery('#billing_city').val() !== '';
        let b_zip_code_1   = jQuery('#billing_zip_code').val() !== '';
        let b_state_1      = jQuery('#billing_state').val() !== '';
        let s_first_name_1 = jQuery('#shipping_first_name').val() !== '';
        let s_last_name_1  = jQuery('#shipping_last_name').val() !== '';
        let s_address_1    = jQuery('#shipping_address').val() !== '';
        let s_city_1       = jQuery('#shipping_city').val() !== '';
        let s_zip_code_1   = jQuery('#shipping_zip_code').val() !== '';
        let s_state_1      = jQuery('#shipping_state').val() !== '';
        let is_filled_1 = b_first_name_1 && b_last_name_1 && b_address_1 && b_city_1 && b_zip_code_1 && b_state_1 && s_first_name_1 && s_last_name_1 && s_address_1 && s_city_1 && s_zip_code_1 && s_state_1;
        if (!is_filled_1) {
            jQuery('#erp-price-reporter-form-checkout .btn-add-new-card').addClass('checkout-add-card-disable')
        }
    }, 2000)
    let header = jQuery('.fixed-header')
    if(header.length) {
        let headerHeight = Math.floor(header.height() - 1);
        jQuery('#page').css({'padding-top': headerHeight + 'px'})
    }
    jQuery(window).on('resize', function(){
        let header = jQuery('.fixed-header')
        if(header.length) {
            let headerHeight = Math.floor(header.height() - 1);
            jQuery('#page').css({'padding-top': headerHeight + 'px'})
        }
    });
})